"use client";

// Deep imports bypass the featured/* barrel files. Next.js App Router
// tree-shaking is unreliable across "use client" boundaries when importing
// from re-export barrels, which can leak unused sibling modules (e.g. the
// bus barrel's GoogleMapCard pulls in @react-google-maps/api). Importing
// each component from its exact file keeps the initial bundle lean without
// touching SSR behavior.

import PopularListItemCard from "@/components/PopularListItemCard";
import RouteCard from "@/components/pages/bus/cards/RouteCard.jsx";
import OpportunitiesCardWrapper from "@/components/OpportunitiesCardWrapper";

import CampaignCard from "@/components/featured/common/cards/CampaignCard";
import BenefitCard from "@/components/featured/common/cards/BenefitCard";
import BrandCard from "@/components/featured/common/cards/BrandCard";
import RegisterBanner from "@/components/featured/common/banner/RegisterBanner";
import PopularLocationCard from "@/components/featured/common/cards/PopularLocationCard";
import AppBanner from "@/components/featured/common/banner/AppBanner";
import IconText from "@/components/featured/common/cards/IconText";
import DestinationCard from "@/components/featured/common/cards/DestinationCard";

import BlogCard from "@/components/featured/bus/cards/BlogCard";
import TravelDealCard from "@/components/featured/bus/cards/TravelDealCard";
import RouteDealCard from "@/components/featured/bus/cards/RouteDealCard";
import CommonListItemCard from "@/components/featured/bus/cards/CommonListItemCard";

import LastMinuteTabbedSwiper from "@/components/LastMinuteTabbedSwiper";

export const componentRegistry = {
  OpportunitiesCardWrapper,
  CampaignCard,
  PopularLocationCard,
  PopularListItemCard,
  CommonListItemCard,
  BenefitCard,
  BrandCard,
  BlogCard,
  AppBanner,
  RegisterBanner,
  RouteCard,
  TravelDealCard,
  RouteDealCard,
  LastMinuteTabbedSwiper,
  IconText,
  DestinationCard,
};

export const itemPropMapping = {
  OpportunitiesCardWrapper: "stats",
  CampaignCard: "item",
  PopularLocationCard: "item",
  PopularListItemCard: "item",
  CommonListItemCard: "item",
  BenefitCard: "item",
  BrandCard: "brand",
  BlogCard: "post",
  RouteCard: "item",
  TravelDealCard: "item",
  RouteDealCard: "item",
  DestinationCard: "item",
};
